<script setup lang="ts">
// Visual marker that a listing is a third-party / informational event (mirrored
// from Arvee Almanac) rather than a joinable, community-created Arvee event.
// Self-contained — no external state.

type ChipVariant =
  | 'flat'
  | 'text'
  | 'elevated'
  | 'tonal'
  | 'outlined'
  | 'plain';

withDefaults(
  defineProps<{
    variant?: ChipVariant;
  }>(),
  { variant: 'tonal' },
);
</script>

<template>
  <v-chip
    color="secondary"
    prepend-icon="mdi-web"
    :variant="variant"
    size="small"
    label
  >
    Informational
  </v-chip>
</template>
